import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';;
declare var $: any;
@Injectable({
    providedIn: 'root'
})
export class AlertService{
    private message$: Subject<any> = new Subject<any>();
    setMessage(msg: string){
        this.message$.next(msg);
        // this.showAlert();
    }

    success(message: string){
        this.message$.next({ class: 'bg-success', text: message });
    }

    error(message: string){
        this.message$.next({ class: 'bg-danger', text: message });
    }

    info(message: string){
        this.message$.next({ class: 'bg-primary', text: message });
    }

    getAlert() : Observable<string>{
        return this.message$.asObservable();
    }

    showAlert(){
        $('.toast').toast('show');
    }
}
